var auraa = {
    slider: function(){
        $('.qzqans_slider').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true
        });
        $('.qzqarw_next').on('click', function() {
            $('.qzqans_slider').slick('slickNext');
        });

        $('.qzqarw_priv').on('click', function() {
             $('.qzqans_slider').slick('slickPrev');
        });
    },
    quiz: function(){

        var f_option = [];
        var answer =  {
                            "Q1": {
                                "A": {"ST_DRY": 3, "ST_COMBO": 1},
                                "B": {"ST_COMBO": 2, "ST_DRY": 1},
                                "C": {"ST_OILY": 3, "ST_COMBO": 1}
                            },
                            "Q2": {
                                "A":  {"ST_DRY": 3},
                                "B":  {"ST_COMBO": 3},
                                "C":  {"ST_OILY": 3}
                            },
                            "Q3": {
                                "A": {"ST_DRY": 2},
                                "B":{"ST_COMBO": 2},
                                "C": {"ST_OILY": 2}
                            },
                            "Q4": {
                                "A": {"ST_OILY": 2, "C_PORES": 2, "C_TEXTURE": 1},
                                "B": {"ST_COMBO": 1, "C_PORES": 1},
                                "C": {"ST_DRY": 1}
                            },
                            "Q5": {
                                "A": {"C_SENS": 4},
                                "B": {"C_SENS": 2},
                                "C": {"none": 0}
                            },
                            "Q6": {
                                "A": {"C_SENS": 3},
                                "B": {"C_SENS": 1},
                                "C": {"none": 0}
                            },
                            "Q7": {
                                "A": {"C_SENS": 2},
                                "B": {"C_SENS": 1},
                                "C": {"none": 0}
                            },
                            "Q8": {
                                "A": {"C_PORES": 2, "C_TEXTURE": 1},
                                "B": {"C_PORES": 1},
                                "C": {"none": 0}
                            },
                            "Q9": {
                                "A": {"C_ACNE": 0},
                                "B": {"C_ACNE": 3},
                                "C": {"C_ACNE": 6}
                            },
                            "Q10": {
                                "A": {"C_PIGMENT": 4},
                                "B": {"C_PIGMENT": 2},
                                "C": {"none": 0}
                            },
                            "Q11": {
                                "A":  {"C_DULL": 4},
                                "B":  {"C_DULL": 2},
                                "C": {"none": 0}
                            },
                            "Q12": {
                                "A": {"C_TEXTURE": 3},
                                "B": {"C_TEXTURE": 1},
                                "C": {"none": 0}
                            },
                            "Q13": {
                                "A":  {"C_AGING": 3},
                                "B":  {"C_AGING": 1},
                                "C":  {"none": 0}
                            },
                            "Q14": {
                                "A":  {"C_AGING": 3},
                                "B":  {"C_AGING": 1},
                                "C":  {"none": 0}
                            },
                            "Q15": {
                                "A":  {"C_UNDER": 3},
                                "B":  {"C_UNDER": 1},
                                "C":  {"none": 0}
                            },
                            "Q16": {
                                "A":  {"OVERHAUL_FLAG": true},
                                "B":  {"OVERHAUL_FLAG": false},
                                "C":  {"OVERHAUL_FLAG": false}
                            },
                            "Q17": {
                                "A":  {"H_EXF": 0, "C_DULL": 1},  
                                "B":  {"H_EXF": 1},
                                "C":  {"H_EXF": 2, "C_SENS": 1 }, 
                            },
                            "Q18": {
                            "A":  {"H_SPF": 0, "C_PIGMENT": 1},  
                            "B":  {"H_SPF": 1 },
                            "C":  {"H_SPF": 2 }
                            },
                            "Q19": {
                            "A":  {"H_MAKEUP": 2 },
                            "B":  {"H_MAKEUP": 1 },
                            "C":  {"H_MAKEUP": 0 }
                            },
                            "Q20": {
                            "A":  {"C_TEXTURE": 2, "C_PORES": 1 },
                            "B":  {"C_TEXTURE": 1 },
                            "C": {"none": 0}
                            },
                            "Q21": {
                            "A":  {"H_WATER": 0, "C_DULL": 1},  
                            "B":  {"H_WATER": 1 },
                            "C":  {"H_WATER": 2 }
                            },
                            "Q22": {
                            "A":  {"H_SLEEP": 0, "C_UNDER": 1, "C_DULL": 1},
                            "B":  {"H_SLEEP": 1 },
                            "C":  {"H_SLEEP": 2 }
                            },
                            "Q23": {
                            "A":  {"B_TIER": 1 },
                            "B":  {"B_TIER": 2 },
                            "C":  {"B_TIER": 3 }
                            },
                            "Q24": {
                            "A":  {"H_TREND": 2, "C_SENS": 1},
                            "B":  {"H_TREND": 1 },
                            "C":  {"H_TREND": 0 }
                            },
                            "Q25": {
                            "A":  {"P_FINISH": "MATTE" },
                            "B":  {"P_FINISH": "DEWY" },
                            "C":  {"P_FINISH": "NATURAL" }
                            },
                            "Q26": {
                            "A":  {"P_ECO": "YES" },
                            "B":  {"P_ECO": "YES" },
                            "C":  {"P_ECO": "NO" }
                            },
                            "Q27": {
                            "A":  {"HR_TIGHT": "HIGH" },
                            "B":  {"HR_TIGHT": "MID" },
                            "C":  {"HR_TIGHT": "LOW" }
                            },
                            "Q28": {
                            "A":  {"HR_DANDRUFF": "YES" },
                            "B":  {"HR_DANDRUFF": "YES" },
                            "C":  {"HR_DANDRUFF": "NO" }
                            },
                            "Q29": {
                            "A":  {"HR_TYPE": "CURLY" },
                            "B":  {"HR_TYPE": "WAVY" },
                            "C":  {"HR_TYPE": "STRAIGHT" }
                            },
                            "Q30": {
                            "A":  {"HR_HEAT": "HIGH" },
                            "B":  {"HR_HEAT": "MID" },
                            "C":  {"HR_HEAT": "LOW" }
                            }
                        };

        
        $('.pgzqans_item').on('click', function(){
              $(this).siblings().removeClass("active");
              $(this).addClass("active");
        });

        // next prev
        $('.pgzq__item').on('click', function(){
            var id = parseInt($(this).closest('.pgzq_next_prev').attr('data-id'));

             // check all option
             var all_option = true; 

            if($(this).hasClass('pgzq__prev')){
                id -=1;
            }else{
                 $('.pgzq_wapper[data-id="'+id+'"] .pgzq_flx .pgzq_item').each(function(){
                    if ($(this).find('.pgzqans_item.active').length > 0) {
                         
                        }else{
                            all_option = false;
                        }
                }); 
                id +=1;
            } 
           
            if(all_option){
                $('.pgzq_wapper').removeClass('active');
                $('.pgzq_wapper[data-id="'+id+'"]').addClass('active');
                $(this).closest('.pgzq_next_prev').attr('data-id', id);
                $('.pgzq_error').hide();
            }else{
                $('.pgzq_error').show();
            }

            if($('.pgzq_wapper.active').hasClass('last')){
                $('.pgzq__next').hide();
                result();
                show_result();
            }else{
                $('.pgzq__next').show();
            }
             
        });


        function result(){
            r_option = [];  

            $('.pgzq_box .pgzq_list').each(function(){
                var that = $(this);
                that.find('.pgzq_flx .pgzq_item').each(function(){
                    var item = $(this).data('q');
                    var value = $(this).find('.pgzqans_item.active').data('a');
                    update_option(item, value);  
                });
            });   
           // console.log(r_option);   

            // sort
            f_option = mergeAndSortOptions(r_option);
            //console.log(f_option);   
        }


        function mergeAndSortOptions(r_option) {
                var result = {};

                // Merge logic
                $.each(r_option, function(i, obj) {
                    $.each(obj, function(key, value) {
                    if (typeof value === 'number') {
                        result[key] = (result[key] || 0) + value;
                    } else {
                        if (!(key in result)) {
                        result[key] = value;
                        }
                    }
                    });
                });

                // Sort keys alphabetically
                var sortedKeys = Object.keys(result).sort();

                // Convert back to array of objects
                var finalArr = $.map(sortedKeys, function(key) {
                    var obj = {};
                    obj[key] = result[key];
                    return obj;
                });

                return finalArr;
        }

        function update_option(item, value){
            // console.log(item);
             var selected = answer[item]?.[value];

            if(selected){
                //console.log(item); 
                for(var key in selected){
                    var obj = {};
                    obj[key] = selected[key];
                    
                    r_option.push(obj);
                }
            }   
        }

       
        function find_max_value(){
            let counts = {};
            let maxValue = null;
            let maxCount = 0;

            hold_value.forEach(function(item) {
                counts[item] = (counts[item] || 0) + 1;
                if (counts[item] > maxCount) {
                    maxCount = counts[item];
                    maxValue = item;
                }
            });

            return maxValue;
        }


        function show_result(){
            console.log(f_option);  
            // 1 Skin Type 
                var ST_DRY = f_option['ST_DRY']; 
                var values = {
                    ST_DRY: f_option['ST_DRY'],
                    ST_COMBO: f_option['ST_COMBO'],
                    ST_OILY: f_option['ST_OILY']
                }; 
                var sorted = Object.entries(values).sort(function(a, b) {
                return b[1] - a[1];
                }); 
                var max1 = { key: sorted[0][0], value: sorted[0][1] };
                var max2 = { key: sorted[1][0], value: sorted[1][1] }; 


                // Sensitivity mode
                var sens_mode ='';
                if (f_option['C_SENS'] >= 4){
                    sens_mode = 'HIGH';
                } else if(f_option['C_SENS'] >= 2){
                    sens_mode = 'MID';
                } else {
                    sens_mode = 'LOW';
                } 
                $('.sens_mode').html(sens_mode);


                // Clamp concerns
               // for each v in {C_ACNE, C_PIGMENT, C_DULL, C_SENS, C_AGING, C_TEXTURE, C_PORES, C_UNDER}:
                //v = min(10, max(0, v))


                 $.each(f_option, function(index, obj){
                     var key = Object.keys(obj)[0];
                     var value = obj[key];
                     $('#output').append('<div><strong>' + key + ':</strong> ' + value + '</div>');
                });

        }
  
    },
    common_page: function(){ 

        $('.menu-list__link').on('click', function (e) { 

            var href = $(this).attr('href');

            // If link contains #
            if (href.indexOf('#') !== -1) {

                var hash = href.substring(href.indexOf('#'));
                var target = $(hash);

                // SAME PAGE
                if (window.location.pathname === this.pathname) {

                    if (target.length) {
                        e.preventDefault();

                        $('html, body').animate({
                            scrollTop: target.offset().top - 80
                        }, 900);
                    }

                } 
                // OTHER PAGE → allow redirect
                else {
                    window.location.href = href;
                }
            }
        }); 
  
    }
}

$(function(){
    auraa.slider();
    auraa.quiz();
    auraa.common_page();
});